import React from 'react';

function PaginationLeftIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8536 4.64645C13.0488 4.84171 13.0488 5.15829 12.8536 5.35355L8.20711 10L12.8536 14.6464C13.0488 14.8417 13.0488 15.1583 12.8536 15.3536C12.6583 15.5488 12.3417 15.5488 12.1464 15.3536L7.14645 10.3536C6.95118 10.1583 6.95118 9.84171 7.14645 9.64645L12.1464 4.64645C12.3417 4.45118 12.6583 4.45118 12.8536 4.64645Z"
        fill="#121212"
      />
    </svg>
  );
}

export default PaginationLeftIcon;
